import React, { FunctionComponent } from 'react';
import {
  InputGroup, Button, InputGroupAddon, Input,
} from 'reactstrap';
import SearchIcon from '../../SvgIcons/SearchIcon';

type Props = {
  value: string | number;
  placeHolder?: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => any;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => any;
  hasButton?: boolean;
  clearable?: boolean;
  onClear?: () => void;
};

const createClearEvent = (): React.ChangeEvent<HTMLInputElement> =>
  ({
    target: { value: '' },
    currentTarget: { value: '' },
  }) as React.ChangeEvent<HTMLInputElement>;

const SearchInput: FunctionComponent<Props> = (props) => {
  const {
    onChange, value, placeHolder, onClick, hasButton, clearable = false, onClear,
  } = props;
  const hasValue = String(value ?? '').length > 0;

  const clearInput = (): void => {
    if (onClear) {
      onClear();
      return;
    }

    onChange(createClearEvent());
  };

  return (
    <InputGroup>
      <Input
        value={value}
        placeholder={placeHolder || 'Search...'}
        onChange={(event: React.ChangeEvent<HTMLInputElement>): void => {

          if (onChange) {

            onChange(event);
          
          }
        
        }}
      />
      {clearable && hasValue && (
      <InputGroupAddon addonType="append">
        <Button
          color="light"
          onClick={clearInput}
          aria-label="Clear search"
          title="Clear search"
        >
          <i className="fa fa-times" aria-hidden="true" />
        </Button>
      </InputGroupAddon>
      )}
      {hasButton && (
      <InputGroupAddon addonType="append">
        <Button
          style={{ cursor: onClick ? 'pointer' : 'default' }}
          color="primary"
          onClick={(event: React.MouseEvent<HTMLButtonElement>): void => {

            if (onClick) {

              onClick(event);
            
            }
          
          }}
        >
          <SearchIcon cssClass="" title="Search" />
        </Button>
      </InputGroupAddon>
      )}

    </InputGroup>
  );

};
export default SearchInput;
